<template>
    <div>
        <v-row>
            <v-col cols="8">
                <v-card>
                    <v-card-title>
                        لیست امضا
                    </v-card-title>
                    <v-card-text>
                        <div class="container">
                            <div class="row ">
                                <v-data-table2
                                    dense
                                    hide-default-footer
                                    height="400"
                                    fixed-header
                                    disable-pagination
                                    multi-sort
                                        class="margin-auto table-bordered"
                                        :headers="headers"
                                        :items="items"
                                >
                                    <template v-slot:item.row_id="{ item }">
                                        {{item._row_index+1}}
                                    </template>

                                    <template v-slot:item.status="{ item }">
                                        <span v-if="item.status==0">غیر فعال</span>
                                        <span v-if="item.status==1">فعال</span>
                                    </template>
                                    <template v-slot:item.operation="{ item }">

                                        <v-btn @click="edit_item(item)"
                                               title="ویرایش"
                                               outlined small color="warning">
                                            <v-icon
                                                    small
                                                    color="warning"
                                            >
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                        <v-btn @click="delete_item_dialog(item)"
                                               title="حذف"
                                               outlined small color="error">
                                            <v-icon
                                                    small
                                                    color="error"
                                            >
                                                mdi-delete
                                            </v-icon>
                                        </v-btn>
                                    </template>

                                </v-data-table2>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="4">
                <v-card>
                    <v-card-title>
                        افزودن امضا
                    </v-card-title>
                    <v-card-text>

                        <v-text-field
                                id="load_type_name"
                                dense
                                v-model="model.title"
                                v-on:keyup.enter="another_focus('sugnature_name')"
                                label="عنوان امضا"/>
                        <v-text-field
                                id="sugnature_name"
                                dense
                                v-model="model.name"
                                v-on:keyup.enter="another_focus('sugnature_status')"
                                label="نام امضا"/>
                        <v-checkbox
                                id="sugnature_status"
                                dense
                                v-model="model.status"
                                :checked.sync="model.status"
                                :value.sync="model.status"
                                v-on:keyup.enter="another_focus('add_signatuer')"
                                label="وضعیت"/>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="status_form==0" color="success" id="add_signatuer" @click="insert_data()">ثبت</v-btn>
                        <v-btn v-if="status_form!=0" color="warning" id="add_signatuer" @click="insert_data()">ویرایش
                        </v-btn>
                        <v-btn color="warning" @click="reset_form()">انصراف</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    import { bus } from '../main'
    import Vue from 'vue'

    export default {
        name: 'Signatures',
        components: {},
        data () {
            return {
                confirm_delete_name:"confirm_delete"+new Date().getTime()+"_"+this.$vnode.tag,
                items: [],
                status_form: 0,
                model: {
                    code: '',
                    name: '',
                    title: '',
                    status: true,
                },
                headers: [
                    {
                        text: 'ردیف',
                        value: 'row_id'
                    },
                    {
                        text: 'عنوان امضا',
                        value: 'title'
                    },
                    {
                        text: 'نام امضا',
                        value: 'name'
                    },
                    {
                        text: 'وضعیت',
                        value: 'status'
                    },
                    {
                        text: 'عملیات',
                        value: 'operation'
                    }
                ]
            }
        },
        mounted () {
            this.get_data()
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        },
        methods: {
            reset_form () {
                this.model = {
                    title: '',
                    code: '',
                    name: '',
                    status: true,
                }
                this.status_form = 0
            },
            edit_item (item) {
                this.model = item
                if(this.model.status==1){
                    this.model.status=true;
                }else{
                    this.model.status=false;
                }
                this.status_form = item.id
            },
            get_data () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/signatures/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.items = response.data.data

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            insert_data () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                var url = '/api/signatures/insert'
                if (this.status_form != 0) {
                    url = '/api/signatures/update'
                    formData.append('id', this.status_form)
                }
                // formData.append('code', this.model.code)
                formData.append('name', this.model.name)
                formData.append('title', this.model.title)
                if(this.model.status){
                    formData.append('status', 1)
                }else{
                    formData.append('status', 0)
                }

                this.axios.post(url, formData, {}).then(function (response) {
                    self.$root.modal_component.show_api_response_modals(response)

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        self.reset_form()
                        self.get_data()
                    }
                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal("هشدار", "آیا مایل به حذف این ردیف هستید؟", ['تایید'], this.confirm_delete_name);
                this.status_form = item.id;

            },
            delete_item() {
                const self = this;
                const formData = new FormData()
                const url = '/api/signatures/delete';
                formData.append('id', this.status_form);

                this.axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);
                    self.status_form = 0;

                    self.get_data();


                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
        }
    }
</script>
